import { Tooltip } from "antd";
import styles from './index.module.sass'
import { convertPriceToString } from "../../index.component";

import infoIcon from '@@/mixing/images/info-icon.svg';


export function CompAdditional({
    idx,
    buyer,
    qty,
    price,
    pricePerTon,
    distance,
    netto,
    weight,
    priceLogistic,
  }: {
    idx: number;
    buyer: [string, string];
    qty: [number, number];
    price: [number, number];
    pricePerTon: [number, number];
    distance: [number, number];
    netto: [number, number];
    weight: [number, number];
    priceLogistic: [number, number];
  }) {
    return (
      <Tooltip
        placement="bottomLeft"
        arrow={false}
        color="#fff"
        overlayStyle={{ minWidth: '450px' }}
        overlayInnerStyle={{
          borderRadius: 16,
          display: 'flex',
          backgroundColor: '#fff',
          minWidth: 360,
        }}
        className={styles.tooltipComp}
        title={
          <div className={styles.tRoot}>
          <span className={styles.mainTitle}>
              при продаже по отдельности друг от друга:
            </span>
          <div className={styles.compAdditional}>
            {/* <span className={styles.mainTitle}>
              при продаже по отдельности друг от друга:
            </span> */}
            <div className={styles.tooltipCompItem}>
              <span className={styles.title}>компонент 1</span>
              <span>вес</span>
              <span>{weight[0]}</span>
              <span>количество рукавов</span>
              <span>{qty[0]}</span>
              <span>стоимость пшеницы</span>
              <span>{convertPriceToString(price[0])}</span>
              <span>цена</span>
              <span>{convertPriceToString(pricePerTon[0])}</span>
              <span>покупатель</span>
              <span>{buyer[0]}</span>
              <span>стоимость логистики</span>
              <span>
                {convertPriceToString(priceLogistic[0])}{' '}
                <span className={styles.postfix}>{distance[0]} км</span>
              </span>
              <span>
                <span>стоимость нетто</span>
              </span>
              <span>{convertPriceToString(netto[0])}</span>
            </div>
            <div className={styles.separator}></div>
            <div className={styles.tooltipCompItem}>
              <span className={styles.title2}>компонент 2</span>
              <span>вес</span>
              <span>{weight[1]}</span>
              <span>количество рукавов</span>
              <span>{qty[1]}</span>
              <span>стоимость пшеницы</span>
              <span>{convertPriceToString(price[1])}</span>
              <span>цена</span>
              <span>{convertPriceToString(pricePerTon[1])}</span>
              <span>покупатель</span>
              <span>{buyer[1]}</span>
              <span>стоимость логистики</span>
              <span>
                {convertPriceToString(priceLogistic[1])}{' '}
                <span className={styles.postfix}>{distance[1]} км</span>
              </span>
              <span>
                <span>стоимость нетто</span>
              </span>
              <span>{convertPriceToString(netto[1])}</span>
            </div>
          </div>
          </div>
        }
      >
        <img alt="icon" src={infoIcon} className={styles.icon} />
      </Tooltip>
    );
  }
  